import styled from 'styled-components'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { useState } from 'react'
import logoImage from '../assets/images/logo.png'
import logowhite from '../assets/images/logo-white.png'

const Nav = styled.nav`
  background: ${props => props.isWeb3Page ? '#0f172a' : 'white'};
  position: relative;
  z-index: 1000;
  
//   box-shadow: ${props => props.isWeb3Page ? 'none' : '0 2px 4px rgba(0,0,0,0.1)'};
`

const NavContainer = styled.div`


//   margin: 0 auto;
//   padding: 0 1rem;
`

const NavContent = styled.div`
  display: flex;
  justify-content: space-between;
  height: 8rem;
`

const Logo = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
`

const LogoImage = styled.img`
  height: 100%;
  width: 450px;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 200px;
  }

  @media (max-width: 480px) {
    width: 150px;
  }
`

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media (max-width: 768px) {
    display: none;
  }
`

const MobileNavLinks = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: ${props => props.isWeb3Page ? '#1e293b' : 'white'};
    padding: 1rem 1rem 2rem 1rem;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transform: ${({ isOpen }) => isOpen ? 'translateY(0)' : 'translateY(-100%)'};
    opacity: ${({ isOpen }) => isOpen ? '1' : '0'};
    visibility: ${({ isOpen }) => isOpen ? 'visible' : 'hidden'};
    transition: all 0.3s ease-in-out;
    z-index: 1000;
  }
`

const HamburgerButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const HamburgerIcon = styled.div`
  width: 24px;
  height: 2px;
  background: ${({ isOpen, isWeb3Page }) => 
    isOpen ? 'transparent' : isWeb3Page ? '#e2e8f0' : '#1e293b'};
  position: relative;
  transition: all 0.3s ease-in-out;
    margin-right: 40px;
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 24px;
    height: 2px;
    background: ${props => props.isWeb3Page ? '#e2e8f0' : '#1e293b'};
    transition: all 0.3s ease-in-out;
  }

  &::before {
    transform: ${({ isOpen }) => isOpen ? 'rotate(45deg)' : 'translateY(-8px)'};
  }

  &::after {
    transform: ${({ isOpen }) => isOpen ? 'rotate(-45deg)' : 'translateY(8px)'};
  }
`

const DesktopLink = styled(NavLink)`
  text-decoration: none;
  color: ${props => props.isWeb3Page ? '#e2e8f0' : '#1e293b'};
  font-size: 1.5rem;
  font-weight: 300;
  transition: all 0.3s ease;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 2px;
    background: #6366f1;
    transition: all 0.3s ease;
  }

  &:hover {
    color: #818cf8;
    
    &::after {
      width: 80%;
      background: #818cf8;
    }
  }

  &.active {
    color: #6366f1;
    
    &::after {
      width: 80%;
      background: #6366f1;
    }
  }
`

const MobileLink = styled(NavLink)`
  padding: 0.75rem 1rem;
  text-decoration: none;
  color: ${props => props.isWeb3Page ? '#e2e8f0' : '#1e293b'};
  transition: all 0.3s ease;
  font-size: 1.2rem;
  border-left: 3px solid transparent;

  &:hover {
    color: #818cf8;
    background: rgba(99, 102, 241, 0.1);
    border-left-color: #818cf8;
  }

  &.active {
    color: #6366f1;
    background: rgba(99, 102, 241, 0.1);
    border-left-color: #6366f1;
  }
`

const QuoteButton = styled(Link)`
  margin: 1rem;
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white !important;
  text-decoration: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 500;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(99, 102, 241, 0.2);

  @media (max-width: 768px) {
    margin: 0 auto;
    width: calc(100% - 5rem);
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(99, 102, 241, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()
  const isWeb3Page = location.pathname === '/web3-services'

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const scrollToContact = (e) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
    if (toggleMenu) toggleMenu(); // Close mobile menu if it's open
  };

  return (
    <Nav isWeb3Page={isWeb3Page}>
      <NavContainer>
        <NavContent>
          <Logo to="/">
            <LogoImage 
              src={isWeb3Page ? logowhite : logoImage} 
              alt="Company Logo" 
            />
          </Logo>
          
          <NavLinks>
            <DesktopLink to="/web2-services" isWeb3Page={isWeb3Page}>Web2 Services</DesktopLink>
            <DesktopLink to="/web3-services" isWeb3Page={isWeb3Page}>Web3 Services</DesktopLink>
            <DesktopLink to="/about" isWeb3Page={isWeb3Page}>About</DesktopLink>
            <QuoteButton to="/contact" onClick={scrollToContact}>Get Quote</QuoteButton>
          </NavLinks>

          <HamburgerButton onClick={toggleMenu} aria-label="Toggle menu">
            <HamburgerIcon isOpen={isOpen} isWeb3Page={isWeb3Page} />
          </HamburgerButton>

          <MobileNavLinks isOpen={isOpen} isWeb3Page={isWeb3Page}>
            <MobileLink to="/" onClick={toggleMenu} end isWeb3Page={isWeb3Page}>Home</MobileLink>
            <MobileLink to="/web2-services" onClick={toggleMenu} isWeb3Page={isWeb3Page}>Web2 Services</MobileLink>
            <MobileLink to="/web3-services" onClick={toggleMenu} isWeb3Page={isWeb3Page}>Web3 Services</MobileLink>
            <MobileLink to="/about" onClick={toggleMenu} isWeb3Page={isWeb3Page}>About</MobileLink>
            <QuoteButton to="/contact" onClick={scrollToContact}>Get Quote</QuoteButton>
          </MobileNavLinks>
        </NavContent>
      </NavContainer>
    </Nav>
  )
}

export default Navbar